// extracted by mini-css-extract-plugin
export default {"StackImgContainer":"Stack_StackImgContainer__mVgnG","StackTile":"Stack_StackTile__I1QSW"};